import { ICountryMySuffix } from 'src/app/shared/model//country-my-suffix.model';
import { IPolicyMySuffix } from 'src/app/shared/model//policy-my-suffix.model';
import { IAddressMySuffix } from 'src/app/shared/model/address-my-suffix.model';
import { FileDataMySuffix, IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { IInsuranceCompanySurveyAssociationPriority } from 'src/app/shared/model/insurance-company-my-suffix.model';


export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum TaxResponsibilityType {
    SELF = 'SELF',
    INSURER = 'INSURER',
    BROKER = 'BROKER',
    CLIENT = 'CLIENT'
}

export interface IUnderwriterMySuffix {
    id?: number;
    name?: string;
    primaryContactNumber?: string;
    pContactCountryCode?: number;
    primaryContactCountryCode?: ICountryMySuffix;
    secondaryContactNumber?: string;
    primaryEmailAddress?: string;
    secondaryEmailaddress?: string;
    activeStatus?: ActiveStatus;
    signatureId?: number;
    underwriterAddressId?: number;
    primaryContactCountryId?: number;
    secondaryContactCountryId?: number;
    licensedNonAdmitCountries?: ICountryMySuffix[];
    excludeCountries?: ICountryMySuffix[];
    policies?: IPolicyMySuffix[];
    primaryContactCountryName?: string;
    secondaryContactCountryName?: string;
    underwriterAddressName?: string;
    address?: IAddressMySuffix;
    fileDTO?: IFileDataMySuffix;
    taxResponsibility?: TaxResponsibilityType;
    taxIdentificationNumber?: string;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?: string;
    surveyAssociationPriorityInfoDTO?: IInsuranceCompanySurveyAssociationPriority[];
    isAccessPlatform: boolean;
    isUserExisted: boolean;
    superAdminUnderwriterUserId?: number;
    // underwriterInsurer?: any,
    nameWithAddress?: string;
    loginEmailAddress?: string;
}

export class UnderwriterMySuffix implements IUnderwriterMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public primaryContactNumber?: string,
        public pContactCountryCode?: number,
        public primaryContactCountryCode?: ICountryMySuffix,
        public secondaryContactNumber?: string,
        public primaryEmailAddress?: string,
        public secondaryEmailaddress?: string,
        public activeStatus?: ActiveStatus,
        public signatureId?: number,
        public underwriterAddressId?: number,
        public primaryContactCountryId?: number,
        public secondaryContactCountryId?: number,
        public licensedNonAdmitCountries?: ICountryMySuffix[],
        public excludeCountries?: ICountryMySuffix[],
        public policies?: IPolicyMySuffix[],
        public primaryContactCountryName?: string,
        public secondaryContactCountryName?: string,
        public underwriterAddressName?: string,
        public address?: IAddressMySuffix,
        public fileDTO = new FileDataMySuffix(),
        public taxResponsibility: TaxResponsibilityType = TaxResponsibilityType.SELF,
        public taxIdentificationNumber?: string,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public fromEffectiveDate?: string,
        public surveyAssociationPriorityInfoDTO: IInsuranceCompanySurveyAssociationPriority[] = [],
        public isAccessPlatform: boolean = false,
        public isUserExisted: boolean = false,
        public superAdminUnderwriterUserId?: number,
        // public underwriterInsurer?: any,
        public nameWithAddress?: string
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.taxResponsibility = TaxResponsibilityType.SELF;
    }
}
